import {ADMIN_LANG} from "../../../settings";
import React from "react";
import Chart from "react-apexcharts";
import {SelectData} from "../../../types/admin";
import {Col} from "react-bootstrap";

const SelectChart = ({optionsData}: { optionsData: SelectData[] }) => {
    const series = [{
        data: optionsData.map(option => ({
            x: option.name, // Use the name directly
            y: option.selections,
            fillColor: option.points > 0
                ? '#28a745' // Green for positive points
                : option.points < 0
                    ? '#dc3545' // Red for negative points
                    : '#6c757d' // Light gray for zero points
        }))
    }];

    const options: ApexCharts.ApexOptions = {
        chart: {
            type: 'bar',
            toolbar: {
                show: false,
            },
        },
        plotOptions: {
            bar: {
                horizontal: true,
            },
        },
        dataLabels: {
            enabled: true,
            formatter: function (val: number, {dataPointIndex}: { dataPointIndex: number }) {
                const option = optionsData[dataPointIndex];
                return `${val} (${option.percentage})`;
            }
        },
        xaxis: {
            categories: optionsData.map(option => option.name),
        },
        colors: optionsData.map(option =>
            option.points > 0
                ? '#28a745'
                : option.points < 0
                    ? '#dc3545'
                    : '#6c757d'
        ),
        tooltip: {
            y: {
                formatter: function (val: number, {dataPointIndex}: {
                    seriesIndex: number;
                    dataPointIndex: number
                }) {
                    const option = optionsData[dataPointIndex];
                    return `${ADMIN_LANG.selections}: ${val}<br>${ADMIN_LANG.points}: ${option.points} <br>Valintaosuus: ${option.percentage}`;
                },
                title: {
                    formatter: () => ''
                }
            }
        }
    };

    return (
        <Col xs={12} lg={6} className="mb-4 mb-lg-0">
            <div className='admin-card'>
                {optionsData.length > 0
                    ? <Chart options={options} series={series} type='bar' height={350}/>
                    : <h3>{ADMIN_LANG.no_data}</h3>
                }
            </div>
        </Col>
    );
};

export default SelectChart;